import {
  ListLoraRecommendationsByModelDocument,
  ListSimilarLorasDocument,
} from './generated/graphql'
import { createQueryHook, modifyQueryHook } from './utils'

export const useListLoraRecommendationsByModel = modifyQueryHook(
  createQueryHook(ListLoraRecommendationsByModelDocument),
  {
    reduce: r => r?.recommendLorasByModel,
  },
)

export const useListSimilarLoras = modifyQueryHook(
  createQueryHook(ListSimilarLorasDocument),
  {
    reduce: r => r?.recommendSimilarLoras,
  },
)
